import React, { useEffect, useRef, useState } from "react"
// import { FaEllipsis, FaEllipsisVertical } from "react-icons/fa6"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import { FaEllipsisH, FaEye } from "react-icons/fa"
import StarRating from "../../plateform/recruiter/components/StarRating"
import { END_POINT as api, API_END_POINT } from "../../utils/constant"
import CandidateModal from "../../plateform/recruiter/components/Modal/CandidateModal"



export default function Dropdown({ idSelected, serviceSelected, setShowModal, item, offer}) {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showRatingModal, setShowRatingModal] = useState(false)
    const [showCandidateDetailModal, setCandidateDetailModal] = useState(false)
  const navigate = useNavigate()
  const trigger = useRef(null);
  const dropdown = useRef(null)
  const [isOpen, setIsOpen] = useState({
    success: false,
    fails: false
})

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    }
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  })

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  })

  // Api de suppression de service Luciano
  const handleDelete = ()=>{
    axios.post(api+"/api/deleteService/"+idSelected)
    .then((res)=>{
      console.log(res)
      setShowDeleteModal(false)
      setIsOpen({ ...isOpen, success: true });
    })
    .catch((err)=>{
      setShowDeleteModal(false)
      setIsOpen({ ...isOpen, fail: true });
    })
  }
  
    const handleDownload = async (resume) => {
        try {
            // Extraire le nom du fichier du chemin relatif
            const filename = resume.split('/').pop();

            const downloadUrl = `${API_END_POINT}/download/${filename}`;
            console.error('url de téléchargement:',downloadUrl)
            // Effectuer la requête GET pour récupérer le fichier
            const response = await axios.get(downloadUrl, {
                responseType: 'blob', 
            })
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); 
            document.body.appendChild(link)
            link.click();
            document.body.removeChild(link)

            // Libérer l'URL de l'objet Blob
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Erreur lors du téléchargement:', error);
        }
    }

  return (
    <>
    <div className="bg-gray-2  ">
      <div className="container">
        <div className="flex justify-center">
          <div className=" relative inline-block">
            <button
              ref={trigger}
              onClick={() => setDropdownOpen(!dropdownOpen)}
                 className="relative flex items-center justify-end gap-2 text-base text-neutral-500 font-medium text-dark bg-gray-50 border rounded-md p-2
             "
            > 
              <FaEllipsisH/>
            </button>
            <div
              ref={dropdown}
              onFocus={() => setDropdownOpen(true)}
              onBlur={() => setDropdownOpen(false)}
              className={` absolute z-50 mt-2 right-0 top-full w-[230px]  overflow-hidden rounded-md bg-white border shadow-md  ${dropdownOpen ? "block" : "hidden"}`}
            >
            <div>
            <span
            onClick={()=>setCandidateDetailModal(true)}
              className="flex w-full items-center justify-between px-4 py-2.5 text-sm font-medium text-primary-black hover:bg-gray-50  cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <FaEye/>
                Voir Détail
              </span>
            </span>
          </div>

              <div>
                <span
                onClick={()=>handleDownload(item?.resume)}
                  className="flex w-full items-center justify-between px-4 py-2.5 text-sm font-medium text-dark hover:bg-gray-50  cursor-pointer"
                >
                  <span className="flex items-center gap-2">
                  <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                <path d="M18.53 9L13 3.47C12.8595 3.32931 12.6688 3.25018 12.47 3.25H8C7.27065 3.25 6.57118 3.53973 6.05546 4.05546C5.53973 4.57118 5.25 5.27065 5.25 6V18C5.25 18.7293 5.53973 19.4288 6.05546 19.9445C6.57118 20.4603 7.27065 20.75 8 20.75H16C16.7293 20.75 17.4288 20.4603 17.9445 19.9445C18.4603 19.4288 18.75 18.7293 18.75 18V9.5C18.7421 9.3116 18.6636 9.13309 18.53 9ZM13.25 5.81L16.19 8.75H13.25V5.81ZM16 19.25H8C7.66848 19.25 7.35054 19.1183 7.11612 18.8839C6.8817 18.6495 6.75 18.3315 6.75 18V6C6.75 5.66848 6.8817 5.35054 7.11612 5.11612C7.35054 4.8817 7.66848 4.75 8 4.75H11.75V9.5C11.7526 9.69811 11.8324 9.88737 11.9725 10.0275C12.1126 10.1676 12.3019 10.2474 12.5 10.25H17.25V18C17.25 18.3315 17.1183 18.6495 16.8839 18.8839C16.6495 19.1183 16.3315 19.25 16 19.25Z" fill="currentColor"/>

                </svg>
                    Télécharcher le CV
                  </span>
                </span>
              </div>
              <div>
                <span
                onClick={()=>setShowRatingModal(true)}
                  className="flex w-full items-center justify-between px-4 py-2.5 text-sm font-medium text-dark hover:bg-gray-50  cursor-pointer"
                >
                  <span className="flex items-center gap-2">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M4.20999 20.5199C4.11375 20.521 4.01826 20.5029 3.92902 20.4669C3.83977 20.4308 3.75854 20.3775 3.68999 20.3099C3.61139 20.2323 3.55092 20.1383 3.51288 20.0346C3.47485 19.9308 3.4602 19.82 3.46999 19.7099L3.77999 15.8699C3.79328 15.6916 3.87156 15.5244 3.99999 15.3999L15.06 4.33995C15.6762 3.76286 16.4961 3.45361 17.34 3.47995C18.1784 3.48645 18.9828 3.81181 19.59 4.38995C20.1723 4.98795 20.5073 5.7839 20.5277 6.61837C20.5481 7.45284 20.2524 8.26421 19.7 8.88995L8.62999 19.9999C8.50609 20.1234 8.34386 20.201 8.16999 20.2199L4.27999 20.5699L4.20999 20.5199ZM5.20999 16.2599L4.99999 18.9999L7.73999 18.7499L18.64 7.82995C18.8525 7.57842 18.9884 7.27118 19.0314 6.94472C19.0745 6.61827 19.0229 6.28631 18.8828 5.9883C18.7428 5.69028 18.5201 5.43873 18.2413 5.26354C17.9625 5.08834 17.6393 4.99685 17.31 4.99995C17.0936 4.98621 16.8766 5.01633 16.6721 5.0885C16.4676 5.16067 16.2798 5.27341 16.12 5.41995L5.20999 16.2599Z" fill="currentColor"/>
                    </svg>
                    Evaluer
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </div>
    <StarRating show={showRatingModal} setShowModal={setShowRatingModal}/>
    <CandidateModal show={showCandidateDetailModal} onClose={()=>setCandidateDetailModal(false)} application={item} offer={offer}/>
    </>
  );
}
